import { render, staticRenderFns } from "./Modals.vue?vue&type=template&id=56dc5f8e&"
import script from "./Modals.vue?vue&type=script&lang=ts&"
export * from "./Modals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports